import styled from 'styled-components';
import { MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
  svg {
    margin-right: 10px;
    color: #999999;
  }
`;
